import i18next from 'i18next';

i18next.addResources('es_CL', 'nutritionalInfo', {
  calories: '{{calories}} cal/trozo',
  portions: '{{portions}} trozos'
});
